import { useEffect, useRef } from "react"
import { CallStatusMessage, subscribeToCallStatus } from "@/lib/call-status-broadcast"

type CallStatusMessageHandler = (event: MessageEvent<CallStatusMessage>) => void

// Runs the handler whenever another tab/window broadcasts a call status (a transcription
// starting elsewhere on the shared microphone).
export function useIncomingCallStatus(onCallStatus: CallStatusMessageHandler) {
  const handlerRef = useRef(onCallStatus)
  // Keep the handler fresh across renders so the listener always calls the latest closure.
  handlerRef.current = onCallStatus

  useEffect(() => subscribeToCallStatus((event) => handlerRef.current(event)), [])
}
